module.exports = __webpack_public_path__ + "img/main.68d3f58d.png";